<script>
  import { createEventDispatcher } from "svelte";
  import { OverflowMenuItem } from "carbon-components-svelte";

  export let currentSubtask = "";

  const dispatch = createEventDispatcher();
</script>

<OverflowMenuItem
  text="PDD (Beta)"
  disabled={!currentSubtask}
  on:click={() => dispatch("select")}
/>
